import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

const paragraphStyle = { textAlign: "justify" };
const quoteStyle = { color: "#cc5858ff", textAlign: "center" };
const footerStyle = { textAlign: "center" };

const ACTIVITIES = ["Swimming 🏊", "Watching Series and Animes 📺"];

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={paragraphStyle}>
            Hi everyone! I’m <span className="purple">Dheeraj Jain</span> from{" "}
            <span className="purple">Bengaluru, India</span>.
            <br />
            I’m currently working as a{" "}
            <span className="purple">SDE Intern</span> at{" "}
            <span className="purple">Mphasis Ltd</span>.
            <br />I hold a Bachelor's Degree in{" "}
            <span className="purple">
              Computer Science and Engineering
            </span>{" "}
            from <span className="purple">BCE Hassan</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and excited:
          </p>

          <ul>
            {ACTIVITIES.map((activity) => (
              <li key={activity} className="about-activity">
                <ImPointRight /> {activity}
              </li>
            ))}
          </ul>

          <p style={quoteStyle}>"People can't use you if you are useless!" </p>
          <footer className="blockquote-footer" style={footerStyle}>
            Dheeraj Jain
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default React.memo(AboutCard);
